import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createBadgeListBlock,
  createBlockquoteBlock,
  createH2Block,
  createPBlock,
  createUlBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getBorderRadiusOptions } from "../../../utils/imgStyleHelpers";
import { getSizingOptions } from "../../../utils/sizeStyleHelpers";
import {
  getFontSizeOptions,
  getFontWeightOptions,
  getLineHeightOptions,
} from "../../../utils/textStyleHelpers";
import checkBulletImage from "../../Content/UlListBlock/check_bullet.png";
import { primaryBlockDefaultStyles } from "../constants";
import placeholderImage from "./homepage_block_1_default_image.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HomepageBlock3",
  meta: {},
  props: {
    header: {
      meta: {
        name: "Header",
        nameI18n: "builder_ui.prop_type.header",
      },
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Meet Your Coach",
        }),
        createPBlock({
          text: "Transforming leaders at Fortune 500 companies for over 15 years",
        }),
      ],
    },
    leftContent: {
      meta: {
        name: "Left Content",
        nameI18n: "builder_ui.prop_type.left_content",
      },
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "none",
                width: "100%",
                height: "100%",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    rightContent: {
      meta: {
        name: "Right Content",
        nameI18n: "builder_ui.prop_type.right_content",
      },
      prop: "children",
      type: "children",
      value: [
        createBlockquoteBlock({
          text: "“Our community brings together passionate individuals on a journey of transformation. Discover resources, participate in discussions, and connect with experts who can help you achieve meaningful change and growth in your personal and professional life”",
          styles: {
            fontWeight: getFontWeightOptions("600"),
            fontSize: getFontSizeOptions("1.25rem"),
            lineHeight: getLineHeightOptions("1.5"),
          },
        }),
        createPBlock({
          text: "My coaching philosophy centers on developing self-awareness, strategic thinking, and emotional intelligence — the essential foundations of extraordinary leadership that drive measurable results.",
          paragraphStyle: "p3",
        }),
        createBadgeListBlock({
          items: [
            "Featured in Forbes",
            "Harvard Business Review Contributor",
            "TEDx Speaker",
          ],
        }),
        createUlBlock({
          items: [
            {
              text: "Certified Executive Coach (ICF)",
              placeholder: checkBulletImage,
            },
            {
              text: "10,000+ coaching hours with professionals & executives",
              placeholder: checkBulletImage,
            },
            {
              text: "Founder of the Clarity Leadership Collective",
              placeholder: checkBulletImage,
            },
            {
              text: "Former Director of Operations at Fortune 500",
              placeholder: checkBulletImage,
            },
          ],
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: primaryBlockDefaultStyles.backgroundColor,
          category: [DesignProp, GeneralProp],
        }),
        padding: getPaddingOptions({
          defaultValue: primaryBlockDefaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        }),
        margin: getMarginOptions({
          defaultValue: primaryBlockDefaultStyles.margin,
          category: [DesignProp, MarginsProp],
        }),
      },
      meta: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        category: [],
      },
    },
  },
};
